import React from 'react'

import './filter.styl'
class Filters extends React.Component  {

    form = {}

    shouldComponentUpdate(nextProps) {
        this.props.tab !== nextProps.tab && (this.form = {})
        return true
    }

    filter(data) {
        Object.assign(this.form, data)
        this.props.onClick(this.form);
    }

    filters() {
        throw new Error('filters should be overrride')
    }


    render() {
        return <ul className={"list-filters filters-" + this.props.tab}>
            { this.filters().map(filter => filter.renderer(this.form, filter, this.filter.bind(this))) }
        </ul>
    }
}

export default Filters
